import { render, staticRenderFns } from "./MentalHealthConcernsSection.vue?vue&type=template&id=3cf5bf4a&"
import script from "./MentalHealthConcernsSection.vue?vue&type=script&lang=js&"
export * from "./MentalHealthConcernsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports